export default __webpack_public_path__ + "static/media/pin_drop_icon.ebebd0bd.svg";